import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PageTableLayout from "../../../components/PageTableLayout";
import apiService from "../../../services/apiService";
import {
  FaFilter,
  FaTimes,
  FaEye,
  FaPencilAlt,
  FaUpload,
  FaFileUpload,
} from "react-icons/fa";
import { Button as UIButton } from "../../../components/ui";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Popover,
  PopoverContent,
  PopoverHandler,
  Typography,
  Button,
} from "@material-tailwind/react";
import { BiRefresh } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import { useToast } from "../../../context/ToastContext";
import { GrStatusInfo } from "react-icons/gr";

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp; <span className="text-gray-700">QSet</span>
  </span>
);

const QSetList = () => {
  const navigate = useNavigate();
  const { showSuccess, showError, showInfo, showWarning } = useToast();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState({
    name: "",
    qId: "",
    quesStatus: "",
    solStatus: "",
  });
  const [limit, setLimit] = useState(10);
  const [isFiltered, setIsFiltered] = useState(false);
  const [qId, setQId] = useState(null);
  const [title, setTitle] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [row, setRow] = useState();
  const [statusOpen, setStatusOpen] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [messageQSetId, setMessageQSetId] = useState();
  const [questionConversionOpen, setQuestionConversionOpen] = useState(false);
  const [conversionProgress, setConversionProgress] = useState(null);
  function handleStatusOpen() {
    setStatusOpen(!statusOpen);
  }

  function handleOpenDelete() {
    setQId(null);
    setTitle(null);
    setRow(row);
    setOpenDelete((value) => !value);
  }

  function handleOpenQuestionConversion() {
    setQuestionConversionOpen(false);
    setQId("");
  }

  function handleDelete(deletedRow) {
    const newRows = data.filter((el) => el.id != deletedRow.id);
    setData(newRows);
  }

  async function questionConversion(qSetId) {
    try {
      const progressResponse = await apiService.request(
        `/i/ims/aistatuslog/conversion/check/${qSetId}?type=Question`,
        {
          method: "GET",
        },
      );

      setConversionProgress(progressResponse?.data || null);
      setQuestionConversionOpen(true);
    } catch (err) {
      console.log(err);
      setConversionProgress(null);
      setQuestionConversionOpen(true);
    }
  }

  async function fetchChecked(qSetId) {
    let checkResponse;
    try {
      checkResponse = await apiService.request(
        `/i/ims/aiquestion/statusReport/${qSetId}`,
        {
          method: "GET",
        },
      );
    } catch (err) {
      console.log(err);
    }

    console.log(checkResponse);
    setMessageQSetId(qSetId);
    setStatusArray(checkResponse.data);
    handleStatusOpen();
  }

  const fetchData = useCallback(
    async (page, filterParams = {}, itemsPerPage = limit) => {
      try {
        setLoading(true);

        // Build query parameters
        const params = new URLSearchParams({
          page,
          limit: itemsPerPage,
          totalCount: true,
          //populate: 'website',
          //select: 'website,title,status,uri',
          //select_website: 'title'
        });

        // Add any filter parameters
        Object.entries(filterParams).forEach(([key, value]) => {
          if (value) {
            params.append(key, value);
          }
        });

        const response = await apiService.request(
          `/i/ims/aiqset?${params.toString()}`,
        );
        //console.log(response)

        setData(response.data);

        setTotalRecords(response.totalCount);
        setCurrentPage(page);

        // Check if any columns are applied
        setIsFiltered(
          Object.values(filterParams).some((value) => value !== ""),
        );
      } catch (error) {
        console.error("Error fetching Question Sets:", error);
      } finally {
        setLoading(false);
      }
    },
    [limit],
  );

  // Fetch websites for filter dropdown
  //   const fetchWebsites = useCallback(async () => {
  //     try {
  //       const websiteData = await apiService.request('/i/ims/website?status=true&select=title');

  //       if (Array.isArray(websiteData)) {
  //         setWebsites(websiteData);
  //       } else {
  //         console.error('Website data is not an array:', websiteData);
  //         setWebsites([]);
  //       }
  //     } catch (err) {
  //       console.error('Error fetching websites:', err);
  //       setWebsites([]);
  //     }
  //   }, []);

  useEffect(() => {
    fetchData(1);
    //fetchWebsites();
    //}, [fetchData, fetchWebsites]);
  }, [fetchData]);

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle filter submit
  const handleFilterSubmit = () => {
    fetchData(1, filters);
  };
  const getStageText = (status) => {
    if (!status) return "-";

    return status.message || "-";
  };
  // Handle filter reset
  const handleFilterReset = () => {
    const resetFilters = {
      name: "",
      qId: "",
      quesStatus: "",
      solStatus: "",
    };

    setFilters(resetFilters);
    fetchData(1, resetFilters);
  };

  // Handle page change
  const handlePageChange = (page) => {
    fetchData(page, filters);
  };

  // Handle limit change
  const handleLimitChange = (value) => {
    // Handle both direct value and event object
    const newLimit = Number(
      typeof value === "object" ? value.target.value : value,
    );
    setLimit(newLimit);
    // Reset to first page when changing limit
    fetchData(1, filters, newLimit);
  };

  // Handle add new button click
  const handleAddNew = () => {
    navigate("/tools/qSet/add");
  };

  const uploadForTask = () => {
    navigate("/tools/qSet/taskUpload/68c292712653350dd1336169");
  };

  const actionButtons = [
    {
      label: "Add New",
      onClick: handleAddNew,
      className: "bg-blue-600 hover:bg-blue-700",
    },
    {
      label: "View Task",
      onClick: uploadForTask,
      className: "bg-blue-600 hover:bg-blue-700",
    },
  ];

  const columns = [
    {
      key: "title",
      title: "Name",
    },
    // {
    //   key: 'id',
    //   title: 'QSet Id',
    //   render: (row) => row.id ? row.id : '-',
    //   filterComponent: (
    //     <input
    //       className="w-full border px-2 py-1 rounded text-xs"
    //       placeholder="Filter by Question-Set Id"
    //       value={filters.id}
    //       onChange={(e) => handleFilterChange('id', e.target.value)}
    //     />
    //     // <select
    //     //   className="w-full border px-2 py-1 rounded text-xs"
    //     //   value={filters.name}
    //     //   onChange={(e) => handleFilterChange('name', e.target.value)}
    //     //   disabled={websites.length === 0}
    //     // >
    //     //   <option value="">{websites.length === 0 ? 'Loading...' : 'All QSet'}</option>
    //     //   {websites.map((w) => (
    //     //     <option key={w.id} value={w.id}>{w.title}</option>
    //     //   ))}
    //     // </select>
    //   )
    // },
    {
      key: "qstatus",
      title: "Question Status",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${row.quesStatus === "Uploaded" ? "bg-green-100 text-green-800" : row.quesStatus === "Uploading" ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800"}`}
        >
          {row.quesStatus || "-"}
        </span>
      ),
      filterComponent: (
        <select
          className="w-full border px-2 py-1 rounded text-xs"
          value={filters.quesStatus}
          onChange={(e) => handleFilterChange("quesStatus", e.target.value)}
        >
          <option value="">All Status</option>
          <option value="Uploaded">Uploaded</option>
          <option value="Not Uploaded">Not Uploaded</option>
        </select>
      ),
    },
    {
      key: "qchecked",
      title: "Questions Checked",
      render: (row) => (
        // <Popover placement="top">
        //   <PopoverHandler>

        <div onClick={() => fetchChecked(row.id)}>
          <Button size="sm" color="blue">
            Check
          </Button>
        </div>

        //   </PopoverHandler>
        //   <PopoverContent>
        //     <span>{responses[row.qSet]}</span>
        //   </PopoverContent>
        // </Popover>
      ),
    },
    {
      key: "sstatus",
      title: "Solution Status",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${row.solStatus === "Uploaded" ? "bg-green-100 text-green-800" : row.solStatus === "Uploading" ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800"}`}
        >
          {row.solStatus || "-"}
        </span>
      ),
      filterComponent: (
        <select
          className="w-full border px-2 py-1 rounded text-xs"
          value={filters.solStatus}
          onChange={(e) => handleFilterChange("solStatus", e.target.value)}
        >
          <option value="">All Status</option>
          <option value="Uploaded">Uploaded</option>
          <option value="Not Uploaded">Not Uploaded</option>
        </select>
      ),
    },
    {
      key: "actions",
      title: "Actions",
      render: (row) => (
        <div className="flex space-x-2">
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`view/${row.id}`);
            }}
            variant="outline"
            size="xs"
            title="View"
            className="text-blue-600 border-blue-600 hover:bg-blue-50"
          >
            <FaEye className="h-4 w-4" />
          </UIButton>
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/tools/qSet/edit/${row.id}`, {
                state: {
                  qSet: row,
                },
              });
            }}
            variant="outline"
            size="xs"
            title="Edit"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaPencilAlt className="h-4 w-4" />
          </UIButton>
          {/* <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`question/${row.id}`);
            }}
            variant="outline"
            size="xs"
            title="Upload Question"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaFileUpload className="h-4 w-4" />
          </UIButton> */}
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`question-new/${row.id}`, {
                state: {
                  qSetId: row.id,
                  title: row.title,
                  alias: row.alias,
                  course: row.course,
                  stream: row.stream,
                  totalQuestions: row.totalQuestions,
                  totalMarks: row.totalMarks,
                  duration: row.duration,
                  subject: row.subject,
                },
              });
            }}
            variant="outline"
            size="xs"
            title="Upload Question PDF"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaFileUpload className="h-4 w-4" />
          </UIButton>
          {/* <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`question-new/${row.id}`, {
                state: {
                  qSetId: row.id,
                  title: row.title,
                  alias: row.alias,
                  course: row.course,
                  stream: row.stream,
                  totalQuestions: row.totalQuestions,
                  totalMarks: row.totalMarks,
                  duration: row.duration,
                  subject: row.subject,
                },
              });
            }}
            variant="outline"
            size="xs"
            title="Upload Question PDF"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaFileUpload className="h-4 w-4" />
          </UIButton> */}
          {/* <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`solution/${row.id}`);
            }}
            variant="outline"
            size="xs"
            title="Upload Solution"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaFileUpload className="h-4 w-4" />
          </UIButton> */}
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              navigate(`solution-new/${row.id}`);
            }}
            variant="outline"
            size="xs"
            title="Upload Solution"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <FaFileUpload className="h-4 w-4" />
          </UIButton>
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              //navigate(`solution/${row.id}`);
              setQId(row.id);
              setTitle(row.title);
              setOpenDelete(true);
              setRow(row);
            }}
            variant="outline"
            size="xs"
            title="Delete"
            className="text-amber-600 border-amber-600 hover:bg-amber-50"
          >
            <MdDelete className="h-4 w-4" />
          </UIButton>
          <UIButton
            onClick={(e) => {
              e.stopPropagation();
              questionConversion(row.id);
            }}
            variant="outline"
            size="xs"
            title="Conversion Status"
            className="text-amber-600 border-amber-600 hover:bg-amber-50 "
          >
            <GrStatusInfo />
          </UIButton>
          {/* <div className="flex items-center gap-1">
            <UIButton
              onClick={(e) => {
                e.stopPropagation();
                questionConversion(row.id);
              }}
              variant="outline"
              size="xs"
              title="Conversion Status"
              className="text-amber-600 border-amber-600 hover:bg-amber-50"
            >
              <GrStatusInfo />
            </UIButton>

            {conversionStatusMap[row.id] && (
              <span
                className={`px-2 py-1 text-[10px] rounded-full font-semibold ${
                  conversionStatusMap[row.id]?.activeStep === 3
                    ? "bg-green-100 text-green-700"
                    : conversionStatusMap[row.id]?.activeStep === -1
                      ? "bg-red-100 text-red-700"
                      : "bg-yellow-100 text-yellow-700"
                }`}
              >
                {conversionStatusMap[row.id]?.message || "-"}
              </span>
            )}
          </div> */}
        </div>
      ),
      filterComponent: (
        <div className="flex space-x-1">
          <UIButton
            variant="outline"
            size="xs"
            className="text-blue-600 border-blue-600 hover:bg-blue-50"
            onClick={handleFilterSubmit}
            disabled={
              !filters.name &&
              !filters.qId &&
              !filters.quesStatus &&
              !filters.solStatus
            }
          >
            <FaFilter className="h-3 w-3 mr-1" />
            Filter
          </UIButton>
          <UIButton
            variant="outline"
            size="xs"
            className="text-red-600 border-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleFilterReset}
            disabled={!isFiltered}
          >
            <FaTimes className="h-3 w-3 mr-1" />
            Reset
          </UIButton>
          <UIButton
            variant="outline"
            size="xs"
            className="text-blue-600 border-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => fetchData(1)}
            //disabled={!isFiltered}
          >
            <BiRefresh className="h-3 w-3 mr-1" />
            Refresh
          </UIButton>
        </div>
      ),
    },
  ];

  const handleView = (row) => {
    navigate(`/qSet/view/${row.id}`);
  };

  const handleEdit = (row) => {
    navigate(`/qSet/edit/${row.id}`);
  };

  return (
    <>
      <MessageDialog
        statusOpen={statusOpen}
        handleStatusOpen={handleStatusOpen}
        statusArray={statusArray}
        qSetId={messageQSetId}
      />
      <PageTableLayout
        title="Question Set"
        breadcrumb={breadcrumb}
        columns={columns}
        data={data || []}
        actions={actionButtons}
        loading={loading}
        pagination={{
          currentPage,
          totalRecords,
          totalPages: Math.ceil(totalRecords / limit),
          limit,
          onLimitChange: handleLimitChange,
        }}
        onPageChange={handlePageChange}
        showFiltersInTable={true}
      />
      <DeleteModal
        openDelete={openDelete}
        handleOpen={handleOpenDelete}
        qId={qId}
        title={title}
        handleDelete={handleDelete}
        row={row}
      />
      <QuestionStatusDialog
        handleOpen={handleOpenQuestionConversion}
        questionConversionOpen={questionConversionOpen}
        conversionProgress={conversionProgress}
      />
    </>
  );
};

const DeleteModal = ({
  openDelete,
  handleOpen,
  qId,
  title,
  handleDelete,
  row,
}) => {
  async function deleteQSet() {
    try {
      await apiService.request(`/i/ims/aiqset/${qId}`, {
        method: "DELETE",
      });

      handleDelete(row);
    } catch (err) {
      console.log(err);
      window.alert("Failed to delete");
    }
    handleOpen();
  }

  return (
    <Dialog
      size="sm"
      open={openDelete}
      handler={handleOpen}
      className="bg-transparent shadow-none bg-white"
    >
      <DialogHeader>
        <Typography variant="h3" color="red">
          Warning!!
        </Typography>
      </DialogHeader>
      <DialogBody>
        <Typography className="mb-3 font-normal">
          Are you sure you want to delete the QSet {title} ?
        </Typography>
      </DialogBody>
      <DialogFooter className="flex justify-center">
        <div className="flex gap-3">
          <Button
            onClick={() => deleteQSet()}
            className="bg-red-600 hover:bg-red-700"
          >
            Delete
          </Button>
          <Button onClick={() => handleOpen()}>Cancel</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
};

const MessageDialog = ({
  statusArray,
  statusOpen,
  handleStatusOpen,
  qSetId,
}) => {
  const navigate = useNavigate();

  function checkNavigate(filter) {
    console.log(qSetId);

    navigate(`/tools/qSet/compare/${qSetId}?filter=${filter}`);
  }

  const TABLE_HEAD = ["Question", "Count", ""];

  // const TABLE_ROWS = [
  //   {
  //     name: "John Michael",
  //     job: "Manager",
  //     date: "23/04/18",
  //   },
  //   {
  //     name: "Alexa Liras",
  //     job: "Developer",
  //     date: "23/04/18",
  //   },
  //   {
  //     name: "Laurent Perrier",
  //     job: "Executive",
  //     date: "19/09/17",
  //   },
  //   {
  //     name: "Michael Levi",
  //     job: "Developer",
  //     date: "24/12/08",
  //   },
  //   {
  //     name: "Richard Gran",
  //     job: "Manager",
  //     date: "04/10/21",
  //   },
  // ];

  return (
    <>
      <Dialog open={statusOpen} size="md" handler={handleStatusOpen}>
        <DialogHeader className="flex justify-between items-center border-b">
          <Typography color="blue-gray" variant="h5">
            Question Status Count
          </Typography>

          <Button variant="text" color="gray" onClick={handleStatusOpen}>
            ✕
          </Button>
        </DialogHeader>

        <DialogBody className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full table-auto text-left">
              <thead>
                <tr className="bg-blue-gray-50">
                  {TABLE_HEAD.map((head) => (
                    <th key={head} className="p-4 border-b">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-semibold"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {statusArray?.map(({ _id, count }, index) => {
                  const statusName = _id || "Unseen";

                  return (
                    <tr
                      key={index}
                      className="hover:bg-blue-gray-50 transition"
                    >
                      <td className="p-4 border-b">
                        <Typography variant="small" color="blue-gray">
                          {statusName}
                        </Typography>
                      </td>

                      <td className="p-4 border-b">
                        <span className="inline-flex items-center justify-center rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-600">
                          {count}
                        </span>
                      </td>

                      <td className="p-4 border-b">
                        <Button
                          size="sm"
                          variant="outlined"
                          color="blue"
                          onClick={() => checkNavigate(_id || "")}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              <tfoot>
                <tr className="bg-gray-50">
                  <td className="p-4 font-bold">Total</td>

                  <td className="p-4">
                    <span className="inline-flex items-center justify-center rounded-full bg-green-50 px-3 py-1 text-sm font-bold text-green-600">
                      {statusArray?.reduce(
                        (sum, item) => sum + Number(item?.count || 0),
                        0,
                      )}
                    </span>
                  </td>

                  <td className="p-4">
                    <Button
                      size="sm"
                      color="green"
                      onClick={() => checkNavigate("")}
                    >
                      View All
                    </Button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </DialogBody>

        <DialogFooter className="border-t">
          <Button variant="gradient" color="gray" onClick={handleStatusOpen}>
            Close
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

const QuestionStatusDialog = ({
  handleOpen,
  questionConversionOpen,
  conversionProgress,
}) => {
  const step = Number(conversionProgress?.activeStep ?? 0);

  const status =
    step === 3
      ? "Completed"
      : step === -1
        ? "Failed"
        : conversionProgress?.isRunning
          ? "Running"
          : "Idle";

  const statusClass =
    step === 3
      ? "bg-green-100 text-green-700 border-green-200"
      : step === -1
        ? "bg-red-100 text-red-700 border-red-200"
        : conversionProgress?.isRunning
          ? "bg-yellow-100 text-yellow-700 border-yellow-200"
          : "bg-gray-100 text-gray-700 border-gray-200";

  const progressPercent =
    step === -1 ? 100 : step === 3 ? 100 : Math.min((step / 3) * 100, 100);

  return (
    <Dialog open={questionConversionOpen} size="sm" handler={handleOpen}>
      <DialogHeader className="flex items-start justify-between border-b px-6 py-4">
        <div>
          <Typography color="blue-gray" variant="h5">
            Question PDF Conversion Status
          </Typography>
          <Typography variant="small" className="mt-1 text-gray-500">
            Track current PDF conversion progress
          </Typography>
        </div>

        <Button
          variant="text"
          color="gray"
          onClick={handleOpen}
          className="h-8 w-8 rounded-full p-0 text-lg"
        >
          ×
        </Button>
      </DialogHeader>

      <DialogBody className="px-6 py-6">
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <div className="flex items-start justify-between gap-4">
            <div>
              <Typography
                variant="small"
                className="font-semibold text-gray-500"
              >
                Current Stage
              </Typography>

              <Typography variant="h5" color="blue-gray" className="mt-1">
                {conversionProgress?.message || "No conversion running"}
              </Typography>
            </div>

            <span
              className={`rounded-full border px-3 py-1 text-xs font-semibold ${statusClass}`}
            >
              {status}
            </span>
          </div>

          <div className="mt-5">
            <div className="mb-2 flex justify-between text-xs text-gray-500">
              <span>Progress</span>
              <span>{Math.round(progressPercent)}%</span>
            </div>

            <div className="h-2 overflow-hidden rounded-full bg-gray-200">
              <div
                className={`h-full rounded-full ${
                  step === -1
                    ? "bg-red-500"
                    : step === 3
                      ? "bg-green-500"
                      : "bg-blue-500"
                }`}
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-3">
            <div className="rounded-xl bg-gray-50 p-3">
              <Typography variant="small" className="text-gray-500">
                Active Step
              </Typography>
              <Typography variant="h6">{step}</Typography>
            </div>

            <div className="rounded-xl bg-gray-50 p-3">
              <Typography variant="small" className="text-gray-500">
                Status
              </Typography>
              <Typography variant="h6">{status}</Typography>
            </div>
          </div>

          {conversionProgress?.jobId && (
            <div className="mt-4 rounded-xl bg-gray-50 p-3">
              <Typography variant="small" className="text-gray-500">
                Job ID
              </Typography>
              <Typography variant="small" className="break-all font-medium">
                {conversionProgress.jobId}
              </Typography>
            </div>
          )}
        </div>
      </DialogBody>

      <DialogFooter className="border-t px-6 py-4">
        <Button variant="gradient" color="blue" onClick={handleOpen}>
          Close
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default QSetList;

// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import PageTableLayout from "../../../components/PageTableLayout";
// import apiService from "../../../services/apiService";
// import {
//   FaFilter,
//   FaTimes,
//   FaEye,
//   FaPencilAlt,
//   FaUpload,
//   FaFileUpload,
// } from "react-icons/fa";
// import { Button as UIButton } from "../../../components/ui";
// import {
//   Dialog,
//   DialogBody,
//   DialogFooter,
//   DialogHeader,
//   Input,
//   Popover,
//   PopoverContent,
//   PopoverHandler,
//   Typography,
//   Button,
// } from "@material-tailwind/react";
// import { BiRefresh } from "react-icons/bi";
// import { MdDelete } from "react-icons/md";
// import { useToast } from "../../../context/ToastContext";
// import { GrStatusInfo } from "react-icons/gr";

// const breadcrumb = (
//   <span>
//     Home &nbsp;/&nbsp; <span className="text-gray-700">QSet</span>
//   </span>
// );

// const QSetList = () => {
//   const navigate = useNavigate();
//   const { showSuccess, showError, showInfo, showWarning } = useToast();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [filters, setFilters] = useState({
//     name: "",
//     qId: "",
//     quesStatus: "",
//     solStatus: "",
//   });
//   const [limit, setLimit] = useState(10);
//   const [isFiltered, setIsFiltered] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [qId, setQId] = useState(null);
//   const [title, setTitle] = useState(null);
//   const [openDelete, setOpenDelete] = useState(false);
//   const [row, setRow] = useState();
//   const [statusOpen, setStatusOpen] = useState(false);
//   const [statusArray, setStatusArray] = useState([]);
//   const [messageQSetId, setMessageQSetId] = useState();
//   const [questionConversionOpen, setQuestionConversionOpen] = useState(false);
//   const [conversionProgress, setConversionProgress] = useState(null);
//   function handleStatusOpen() {
//     setStatusOpen(!statusOpen);
//   }

//   function handleOpen() {
//     setQId(null);
//     setTitle(null);
//     setRow(row);
//     setOpen((value) => !value);
//   }

//   function handleOpenDelete() {
//     setQId(null);
//     setTitle(null);
//     setRow(row);
//     setOpenDelete((value) => !value);
//   }

//   function handleOpenQuestionConversion() {
//     setQuestionConversionOpen(false);
//     setQId("");
//   }

//   function handleDelete(deletedRow) {
//     const newRows = data.filter((el) => el.id != deletedRow.id);
//     setData(newRows);
//   }

//   function handleEditRow(editedRow) {
//     const newRows = data.forEach((row) => {
//       if (editedRow.id === row.id) {
//         return editedRow;
//       } else {
//         return row;
//       }
//     });
//     setData(newRows);
//   }

//   async function questionConversion(qSetId) {
//     try {
//       const progressResponse = await apiService.request(
//         `/i/ims/aistatuslog/conversion/check/${qSetId}?type=Question`,
//         {
//           method: "GET",
//         },
//       );

//       setConversionProgress(progressResponse?.data || null);
//       setQuestionConversionOpen(true);
//     } catch (err) {
//       console.log(err);
//       setConversionProgress(null);
//       setQuestionConversionOpen(true);
//     }
//   }

//   async function fetchChecked(qSetId) {
//     let checkResponse;
//     try {
//       checkResponse = await apiService.request(
//         `/i/ims/aiquestion/statusReport/${qSetId}`,
//         {
//           method: "GET",
//         },
//       );
//     } catch (err) {
//       console.log(err);
//     }

//     console.log(checkResponse);
//     setMessageQSetId(qSetId);
//     setStatusArray(checkResponse.data);
//     handleStatusOpen();
//   }

//   const fetchData = useCallback(
//     async (page, filterParams = {}, itemsPerPage = limit) => {
//       try {
//         setLoading(true);

//         // Build query parameters
//         const params = new URLSearchParams({
//           page,
//           limit: itemsPerPage,
//           totalCount: true,
//           //populate: 'website',
//           //select: 'website,title,status,uri',
//           //select_website: 'title'
//         });

//         // Add any filter parameters
//         Object.entries(filterParams).forEach(([key, value]) => {
//           if (value) {
//             params.append(key, value);
//           }
//         });

//         const response = await apiService.request(
//           `/i/ims/aiqset?${params.toString()}`,
//         );
//         //console.log(response)

//         setData(response.data);

//         setTotalRecords(response.totalCount);
//         setCurrentPage(page);

//         // Check if any columns are applied
//         setIsFiltered(
//           Object.values(filterParams).some((value) => value !== ""),
//         );
//       } catch (error) {
//         console.error("Error fetching Question Sets:", error);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [limit],
//   );

//   // Fetch websites for filter dropdown
//   //   const fetchWebsites = useCallback(async () => {
//   //     try {
//   //       const websiteData = await apiService.request('/i/ims/website?status=true&select=title');

//   //       if (Array.isArray(websiteData)) {
//   //         setWebsites(websiteData);
//   //       } else {
//   //         console.error('Website data is not an array:', websiteData);
//   //         setWebsites([]);
//   //       }
//   //     } catch (err) {
//   //       console.error('Error fetching websites:', err);
//   //       setWebsites([]);
//   //     }
//   //   }, []);

//   useEffect(() => {
//     fetchData(1);
//     //fetchWebsites();
//     //}, [fetchData, fetchWebsites]);
//   }, [fetchData]);

//   // Handle filter changes
//   const handleFilterChange = (field, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   // Handle filter submit
//   const handleFilterSubmit = () => {
//     fetchData(1, filters);
//   };
//   const getStageText = (status) => {
//     if (!status) return "-";

//     return status.message || "-";
//   };
//   // Handle filter reset
//   const handleFilterReset = () => {
//     const resetFilters = {
//       name: "",
//       qId: "",
//       quesStatus: "",
//       solStatus: "",
//     };

//     setFilters(resetFilters);
//     fetchData(1, resetFilters);
//   };

//   // Handle page change
//   const handlePageChange = (page) => {
//     fetchData(page, filters);
//   };

//   // Handle limit change
//   const handleLimitChange = (value) => {
//     // Handle both direct value and event object
//     const newLimit = Number(
//       typeof value === "object" ? value.target.value : value,
//     );
//     setLimit(newLimit);
//     // Reset to first page when changing limit
//     fetchData(1, filters, newLimit);
//   };

//   // Handle add new button click
//   const handleAddNew = () => {
//     navigate("/tools/qSet/add");
//   };

//   const uploadForTask = () => {
//     navigate("/tools/qSet/taskUpload/68c292712653350dd1336169");
//   };

//   const actionButtons = [
//     {
//       label: "Add New",
//       onClick: handleAddNew,
//       className: "bg-blue-600 hover:bg-blue-700",
//     },
//     {
//       label: "View Task",
//       onClick: uploadForTask,
//       className: "bg-blue-600 hover:bg-blue-700",
//     },
//   ];

//   const columns = [
//     {
//       key: "title",
//       title: "Name",
//     },
//     // {
//     //   key: 'id',
//     //   title: 'QSet Id',
//     //   render: (row) => row.id ? row.id : '-',
//     //   filterComponent: (
//     //     <input
//     //       className="w-full border px-2 py-1 rounded text-xs"
//     //       placeholder="Filter by Question-Set Id"
//     //       value={filters.id}
//     //       onChange={(e) => handleFilterChange('id', e.target.value)}
//     //     />
//     //     // <select
//     //     //   className="w-full border px-2 py-1 rounded text-xs"
//     //     //   value={filters.name}
//     //     //   onChange={(e) => handleFilterChange('name', e.target.value)}
//     //     //   disabled={websites.length === 0}
//     //     // >
//     //     //   <option value="">{websites.length === 0 ? 'Loading...' : 'All QSet'}</option>
//     //     //   {websites.map((w) => (
//     //     //     <option key={w.id} value={w.id}>{w.title}</option>
//     //     //   ))}
//     //     // </select>
//     //   )
//     // },
//     {
//       key: "qstatus",
//       title: "Question Status",
//       render: (row) => (
//         <span
//           className={`px-2 py-1 rounded-full text-xs ${row.quesStatus === "Uploaded" ? "bg-green-100 text-green-800" : row.quesStatus === "Uploading" ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800"}`}
//         >
//           {row.quesStatus || "-"}
//         </span>
//       ),
//       filterComponent: (
//         <select
//           className="w-full border px-2 py-1 rounded text-xs"
//           value={filters.quesStatus}
//           onChange={(e) => handleFilterChange("quesStatus", e.target.value)}
//         >
//           <option value="">All Status</option>
//           <option value="Uploaded">Uploaded</option>
//           <option value="Not Uploaded">Not Uploaded</option>
//         </select>
//       ),
//     },
//     {
//       key: "qchecked",
//       title: "Questions Checked",
//       render: (row) => (
//         // <Popover placement="top">
//         //   <PopoverHandler>

//         <div onClick={() => fetchChecked(row.id)}>
//           <Button size="sm" color="blue">
//             Check
//           </Button>
//         </div>

//         //   </PopoverHandler>
//         //   <PopoverContent>
//         //     <span>{responses[row.qSet]}</span>
//         //   </PopoverContent>
//         // </Popover>
//       ),
//     },
//     {
//       key: "sstatus",
//       title: "Solution Status",
//       render: (row) => (
//         <span
//           className={`px-2 py-1 rounded-full text-xs ${row.solStatus === "Uploaded" ? "bg-green-100 text-green-800" : row.solStatus === "Uploading" ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800"}`}
//         >
//           {row.solStatus || "-"}
//         </span>
//       ),
//       filterComponent: (
//         <select
//           className="w-full border px-2 py-1 rounded text-xs"
//           value={filters.solStatus}
//           onChange={(e) => handleFilterChange("solStatus", e.target.value)}
//         >
//           <option value="">All Status</option>
//           <option value="Uploaded">Uploaded</option>
//           <option value="Not Uploaded">Not Uploaded</option>
//         </select>
//       ),
//     },
//     {
//       key: "actions",
//       title: "Actions",
//       render: (row) => (
//         <div className="flex space-x-2">
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               navigate(`view/${row.id}`);
//             }}
//             variant="outline"
//             size="xs"
//             title="View"
//             className="text-blue-600 border-blue-600 hover:bg-blue-50"
//           >
//             <FaEye className="h-4 w-4" />
//           </UIButton>
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               //navigate(`edit/${row.id}`);
//               setOpen(true);
//               setQId(row.id);
//               setTitle(row.title);
//               setRow(row);
//             }}
//             variant="outline"
//             size="xs"
//             title="Edit"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <FaPencilAlt className="h-4 w-4" />
//           </UIButton>
//           {/* <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               navigate(`question/${row.id}`);
//             }}
//             variant="outline"
//             size="xs"
//             title="Upload Question"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <FaFileUpload className="h-4 w-4" />
//           </UIButton> */}
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               navigate(`question-new/${row.id}`, {
//                 state: {
//                   qSetId: row.id,
//                   title: row.title,
//                   alias: row.alias,
//                   course: row.course,
//                   stream: row.stream,
//                   totalQuestions: row.totalQuestions,
//                   totalMarks: row.totalMarks,
//                   duration: row.duration,
//                   subject: row.subject,
//                 },
//               });
//             }}
//             variant="outline"
//             size="xs"
//             title="Upload Question PDF"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <FaFileUpload className="h-4 w-4" />
//           </UIButton>
//           {/* <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               navigate(`solution/${row.id}`);
//             }}
//             variant="outline"
//             size="xs"
//             title="Upload Solution"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <FaFileUpload className="h-4 w-4" />
//           </UIButton> */}
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               navigate(`solution-new/${row.id}`);
//             }}
//             variant="outline"
//             size="xs"
//             title="Upload Solution"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <FaFileUpload className="h-4 w-4" />
//           </UIButton>
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               //navigate(`solution/${row.id}`);
//               setQId(row.id);
//               setTitle(row.title);
//               setOpenDelete(true);
//               setRow(row);
//             }}
//             variant="outline"
//             size="xs"
//             title="Delete"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50"
//           >
//             <MdDelete className="h-4 w-4" />
//           </UIButton>
//           <UIButton
//             onClick={(e) => {
//               e.stopPropagation();
//               questionConversion(row.id);
//             }}
//             variant="outline"
//             size="xs"
//             title="Conversion Status"
//             className="text-amber-600 border-amber-600 hover:bg-amber-50 "
//           >
//             <GrStatusInfo />
//           </UIButton>
//           {/* <div className="flex items-center gap-1">
//             <UIButton
//               onClick={(e) => {
//                 e.stopPropagation();
//                 questionConversion(row.id);
//               }}
//               variant="outline"
//               size="xs"
//               title="Conversion Status"
//               className="text-amber-600 border-amber-600 hover:bg-amber-50"
//             >
//               <GrStatusInfo />
//             </UIButton>

//             {conversionStatusMap[row.id] && (
//               <span
//                 className={`px-2 py-1 text-[10px] rounded-full font-semibold ${
//                   conversionStatusMap[row.id]?.activeStep === 3
//                     ? "bg-green-100 text-green-700"
//                     : conversionStatusMap[row.id]?.activeStep === -1
//                       ? "bg-red-100 text-red-700"
//                       : "bg-yellow-100 text-yellow-700"
//                 }`}
//               >
//                 {conversionStatusMap[row.id]?.message || "-"}
//               </span>
//             )}
//           </div> */}
//         </div>
//       ),
//       filterComponent: (
//         <div className="flex space-x-1">
//           <UIButton
//             variant="outline"
//             size="xs"
//             className="text-blue-600 border-blue-600 hover:bg-blue-50"
//             onClick={handleFilterSubmit}
//             disabled={
//               !filters.name &&
//               !filters.qId &&
//               !filters.quesStatus &&
//               !filters.solStatus
//             }
//           >
//             <FaFilter className="h-3 w-3 mr-1" />
//             Filter
//           </UIButton>
//           <UIButton
//             variant="outline"
//             size="xs"
//             className="text-red-600 border-red-600 hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
//             onClick={handleFilterReset}
//             disabled={!isFiltered}
//           >
//             <FaTimes className="h-3 w-3 mr-1" />
//             Reset
//           </UIButton>
//           <UIButton
//             variant="outline"
//             size="xs"
//             className="text-blue-600 border-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
//             onClick={() => fetchData(1)}
//             //disabled={!isFiltered}
//           >
//             <BiRefresh className="h-3 w-3 mr-1" />
//             Refresh
//           </UIButton>
//         </div>
//       ),
//     },
//   ];

//   const handleView = (row) => {
//     navigate(`/qSet/view/${row.id}`);
//   };

//   const handleEdit = (row) => {
//     navigate(`/qSet/edit/${row.id}`);
//   };

//   return (
//     <>
//       <MessageDialog
//         statusOpen={statusOpen}
//         handleStatusOpen={handleStatusOpen}
//         statusArray={statusArray}
//         qSetId={messageQSetId}
//       />
//       <PageTableLayout
//         title="Question Set"
//         breadcrumb={breadcrumb}
//         columns={columns}
//         data={data || []}
//         actions={actionButtons}
//         loading={loading}
//         pagination={{
//           currentPage,
//           totalRecords,
//           totalPages: Math.ceil(totalRecords / limit),
//           limit,
//           onLimitChange: handleLimitChange,
//         }}
//         onPageChange={handlePageChange}
//         showFiltersInTable={true}
//       />
//       <EditModal
//         open={open}
//         handleOpen={handleOpen}
//         qId={qId}
//         qName={title}
//         handleEditRow={handleEditRow}
//         row={row}
//       />
//       <DeleteModal
//         openDelete={openDelete}
//         handleOpen={handleOpenDelete}
//         qId={qId}
//         title={title}
//         handleDelete={handleDelete}
//         row={row}
//       />
//       <QuestionStatusDialog
//         handleOpen={handleOpenQuestionConversion}
//         questionConversionOpen={questionConversionOpen}
//         conversionProgress={conversionProgress}
//       />
//     </>
//   );
// };

// const EditModal = ({ open, handleOpen, qName, qId, handleEditRow, row }) => {
//   const [qSetName, setQSetName] = useState(qName);

//   useEffect(() => {
//     setQSetName(qName);
//   }, [qName]);

//   async function handleSubmit() {
//     let response;
//     const formData = new FormData();
//     formData.append("title", qSetName);

//     try {
//       response = await apiService.request(`/i/ims/aiqset/${qId}`, {
//         method: "PUT",
//         body: formData,
//       });

//       handleEditRow(row);
//     } catch (err) {
//       console.log(err);
//     }

//     handleOpen();
//   }

//   return (
//     <Dialog
//       size="sm"
//       open={open}
//       handler={handleOpen}
//       className="bg-transparent shadow-none bg-white"
//     >
//       <DialogHeader>
//         <Typography variant="h4" color="blue-gray">
//           Edit Your Question Set
//         </Typography>
//       </DialogHeader>

//       <DialogBody>
//         <Typography className="mb-3 font-normal">
//           Question Set Name : {qSetName}
//         </Typography>

//         <Input
//           value={qSetName}
//           onChange={(e) => setQSetName(e.target.value)}
//           label="Question Set Name"
//         />
//       </DialogBody>

//       <DialogFooter className="flex gap-2">
//         <Button
//           variant="outlined"
//           color="red"
//           onClick={(e) => {
//             e.preventDefault();
//             handleOpen(); // dialog close
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={(e) => {
//             e.preventDefault();
//             handleSubmit();
//           }}
//         >
//           Submit
//         </Button>
//       </DialogFooter>
//     </Dialog>
//   );
// };

// const DeleteModal = ({
//   openDelete,
//   handleOpen,
//   qId,
//   title,
//   handleDelete,
//   row,
// }) => {
//   async function deleteQSet() {
//     try {
//       await apiService.request(`/i/ims/aiqset/${qId}`, {
//         method: "DELETE",
//       });

//       handleDelete(row);
//     } catch (err) {
//       console.log(err);
//       window.alert("Failed to delete");
//     }
//     handleOpen();
//   }

//   return (
//     <Dialog
//       size="sm"
//       open={openDelete}
//       handler={handleOpen}
//       className="bg-transparent shadow-none bg-white"
//     >
//       <DialogHeader>
//         <Typography variant="h3" color="red">
//           Warning!!
//         </Typography>
//       </DialogHeader>
//       <DialogBody>
//         <Typography className="mb-3 font-normal">
//           Are you sure you want to delete the QSet {title} ?
//         </Typography>
//       </DialogBody>
//       <DialogFooter className="flex justify-center">
//         <div className="flex gap-3">
//           <Button
//             onClick={() => deleteQSet()}
//             className="bg-red-600 hover:bg-red-700"
//           >
//             Delete
//           </Button>
//           <Button onClick={() => handleOpen()}>Cancel</Button>
//         </div>
//       </DialogFooter>
//     </Dialog>
//   );
// };

// const MessageDialog = ({
//   statusArray,
//   statusOpen,
//   handleStatusOpen,
//   qSetId,
// }) => {
//   const navigate = useNavigate();

//   function checkNavigate(filter) {
//     console.log(qSetId);

//     navigate(`/tools/qSet/compare/${qSetId}?filter=${filter}`);
//   }

//   const TABLE_HEAD = ["Question", "Count", ""];

//   // const TABLE_ROWS = [
//   //   {
//   //     name: "John Michael",
//   //     job: "Manager",
//   //     date: "23/04/18",
//   //   },
//   //   {
//   //     name: "Alexa Liras",
//   //     job: "Developer",
//   //     date: "23/04/18",
//   //   },
//   //   {
//   //     name: "Laurent Perrier",
//   //     job: "Executive",
//   //     date: "19/09/17",
//   //   },
//   //   {
//   //     name: "Michael Levi",
//   //     job: "Developer",
//   //     date: "24/12/08",
//   //   },
//   //   {
//   //     name: "Richard Gran",
//   //     job: "Manager",
//   //     date: "04/10/21",
//   //   },
//   // ];

//   return (
//     <>
//       <Dialog open={statusOpen} size="md" handler={handleStatusOpen}>
//         <DialogHeader className="flex justify-between items-center border-b">
//           <Typography color="blue-gray" variant="h5">
//             Question Status Count
//           </Typography>

//           <Button variant="text" color="gray" onClick={handleStatusOpen}>
//             ✕
//           </Button>
//         </DialogHeader>

//         <DialogBody className="p-0">
//           <div className="overflow-x-auto">
//             <table className="w-full table-auto text-left">
//               <thead>
//                 <tr className="bg-blue-gray-50">
//                   {TABLE_HEAD.map((head) => (
//                     <th key={head} className="p-4 border-b">
//                       <Typography
//                         variant="small"
//                         color="blue-gray"
//                         className="font-semibold"
//                       >
//                         {head}
//                       </Typography>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {statusArray?.map(({ _id, count }, index) => {
//                   const statusName = _id || "Unseen";

//                   return (
//                     <tr
//                       key={index}
//                       className="hover:bg-blue-gray-50 transition"
//                     >
//                       <td className="p-4 border-b">
//                         <Typography variant="small" color="blue-gray">
//                           {statusName}
//                         </Typography>
//                       </td>

//                       <td className="p-4 border-b">
//                         <span className="inline-flex items-center justify-center rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-600">
//                           {count}
//                         </span>
//                       </td>

//                       <td className="p-4 border-b">
//                         <Button
//                           size="sm"
//                           variant="outlined"
//                           color="blue"
//                           onClick={() => checkNavigate(_id || "")}
//                         >
//                           View
//                         </Button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>

//               <tfoot>
//                 <tr className="bg-gray-50">
//                   <td className="p-4 font-bold">Total</td>

//                   <td className="p-4">
//                     <span className="inline-flex items-center justify-center rounded-full bg-green-50 px-3 py-1 text-sm font-bold text-green-600">
//                       {statusArray?.reduce(
//                         (sum, item) => sum + Number(item?.count || 0),
//                         0,
//                       )}
//                     </span>
//                   </td>

//                   <td className="p-4">
//                     <Button
//                       size="sm"
//                       color="green"
//                       onClick={() => checkNavigate("")}
//                     >
//                       View All
//                     </Button>
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </DialogBody>

//         <DialogFooter className="border-t">
//           <Button variant="gradient" color="gray" onClick={handleStatusOpen}>
//             Close
//           </Button>
//         </DialogFooter>
//       </Dialog>
//     </>
//   );
// };

// const QuestionStatusDialog = ({
//   handleOpen,
//   questionConversionOpen,
//   conversionProgress,
// }) => {
//   const step = Number(conversionProgress?.activeStep ?? 0);

//   const status =
//     step === 3
//       ? "Completed"
//       : step === -1
//         ? "Failed"
//         : conversionProgress?.isRunning
//           ? "Running"
//           : "Idle";

//   const statusClass =
//     step === 3
//       ? "bg-green-100 text-green-700 border-green-200"
//       : step === -1
//         ? "bg-red-100 text-red-700 border-red-200"
//         : conversionProgress?.isRunning
//           ? "bg-yellow-100 text-yellow-700 border-yellow-200"
//           : "bg-gray-100 text-gray-700 border-gray-200";

//   const progressPercent =
//     step === -1 ? 100 : step === 3 ? 100 : Math.min((step / 3) * 100, 100);

//   return (
//     <Dialog open={questionConversionOpen} size="sm" handler={handleOpen}>
//       <DialogHeader className="flex items-start justify-between border-b px-6 py-4">
//         <div>
//           <Typography color="blue-gray" variant="h5">
//             Question PDF Conversion Status
//           </Typography>
//           <Typography variant="small" className="mt-1 text-gray-500">
//             Track current PDF conversion progress
//           </Typography>
//         </div>

//         <Button
//           variant="text"
//           color="gray"
//           onClick={handleOpen}
//           className="h-8 w-8 rounded-full p-0 text-lg"
//         >
//           ×
//         </Button>
//       </DialogHeader>

//       <DialogBody className="px-6 py-6">
//         <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
//           <div className="flex items-start justify-between gap-4">
//             <div>
//               <Typography
//                 variant="small"
//                 className="font-semibold text-gray-500"
//               >
//                 Current Stage
//               </Typography>

//               <Typography variant="h5" color="blue-gray" className="mt-1">
//                 {conversionProgress?.message || "No conversion running"}
//               </Typography>
//             </div>

//             <span
//               className={`rounded-full border px-3 py-1 text-xs font-semibold ${statusClass}`}
//             >
//               {status}
//             </span>
//           </div>

//           <div className="mt-5">
//             <div className="mb-2 flex justify-between text-xs text-gray-500">
//               <span>Progress</span>
//               <span>{Math.round(progressPercent)}%</span>
//             </div>

//             <div className="h-2 overflow-hidden rounded-full bg-gray-200">
//               <div
//                 className={`h-full rounded-full ${
//                   step === -1
//                     ? "bg-red-500"
//                     : step === 3
//                       ? "bg-green-500"
//                       : "bg-blue-500"
//                 }`}
//                 style={{ width: `${progressPercent}%` }}
//               />
//             </div>
//           </div>

//           <div className="mt-5 grid grid-cols-2 gap-3">
//             <div className="rounded-xl bg-gray-50 p-3">
//               <Typography variant="small" className="text-gray-500">
//                 Active Step
//               </Typography>
//               <Typography variant="h6">{step}</Typography>
//             </div>

//             <div className="rounded-xl bg-gray-50 p-3">
//               <Typography variant="small" className="text-gray-500">
//                 Status
//               </Typography>
//               <Typography variant="h6">{status}</Typography>
//             </div>
//           </div>

//           {conversionProgress?.jobId && (
//             <div className="mt-4 rounded-xl bg-gray-50 p-3">
//               <Typography variant="small" className="text-gray-500">
//                 Job ID
//               </Typography>
//               <Typography variant="small" className="break-all font-medium">
//                 {conversionProgress.jobId}
//               </Typography>
//             </div>
//           )}
//         </div>
//       </DialogBody>

//       <DialogFooter className="border-t px-6 py-4">
//         <Button variant="gradient" color="blue" onClick={handleOpen}>
//           Close
//         </Button>
//       </DialogFooter>
//     </Dialog>
//   );
// };

// export default QSetList;
